import React, { Fragment } from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

const EmployeesAssetsReportRow = ({
  record,
  handleToggleCollapsed,
  handleGeneratePDF,
  handleGeneratePDF_two,
  signAction,
  collapsed,
  t,
}) => {
  return (
    <Fragment>
      <tr>
        <td>{record.key}</td>
        <td>{record.name}</td>
        <td>{record.lastname}</td>
        <td>{record.position}</td>
        <td className="text-center">{record.total}</td>
        <td className="text-center">
          <a
            className="btn btn-outline-success btn-sm mx-2"
            href="#expand"
            onClick={(e) => {
              e.preventDefault();
              handleToggleCollapsed();
            }}
          >
            {t(
              !collapsed
                ? 'reports.employeesAssets.hideAssets'
                : 'reports.employeesAssets.showAssets'
            )}
            &nbsp;
            <i
              className={classnames('fa', {
                'fa-angle-down': collapsed,
                'fa-angle-up': !collapsed,
              })}
            />
          </a>
          <a
            className="btn btn-outline-primary btn-sm"
            href="#export"
            onClick={(e) => {
              e.preventDefault();
              handleGeneratePDF(record);
            }}
          >
            {t('actions.exportPDF')}
          </a>

          <a
            className="btn btn-outline-dark btn-sm mx-2"
            href="#export"
            onClick={(e) => {
              e.preventDefault();
              handleGeneratePDF_two(record);
            }}
          >
            {t('actions.exportPDFprice')}
          </a>
          {signAction}
        </td>
      </tr>
      <tr className={classnames('table-active', { 'd-none': collapsed })}>
        <td colSpan="7">
          <div className="table-reponsive position-relative">
            <table className="table table-condensed">
              <thead>
                {/* <tr className="text-center">
                <th colSpan="4">{t('reports.employeesAssets.assigned')}</th>
              </tr> */}
                <tr>
                  <th>{t('assets.fields.number')}</th>
                  <th>{t('assets.fields.name')}</th>
                  <th>{t('assets.fields.brand')}</th>
                  <th>{t('assets.fields.model')}</th>
                  <th>{t('assets.fields.serie')}</th>
                </tr>
              </thead>
              <tbody>
                {record.assets.map((asset) => (
                  <tr key={asset.id}>
                    <td>{asset.number}</td>
                    <td>{asset.name}</td>
                    <td>{asset.brand}</td>
                    <td>{asset.model}</td>
                    <td>{asset.serie}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    </Fragment>
  );
};

export default translate()(EmployeesAssetsReportRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/employees_assets/EmployeesAssetsReportRow.js